/* Parse and create querystrings.
 *
 * The parse and stringify interfaces are borrowed from NodeJS's own
 * [querystring.stringify](http://nodejs.org/api/querystring.html). Keys and
 * values are urlencoded/decoded via encodeURIComponent/decodeURIComponent,
 * but custom `sep`/`eq` characters and array values are not supported.
 */
(function (c2) {
  'use strict';

  // Serialize an object into a querystring.
  //
  // Example:
  //    > stringify({color: "blue", cost_lt: "9"});
  //    "color=blue&cost_lt=9"
  function stringify(obj) {
    return Object.keys(obj).map(function (key) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]);
    }).join('&');
  }

  // Deserialize a querystring into an object.
  //
  // Example:
  //    > parse('color=blue&cost_lt=9');
  //    {color: "blue", cost_lt: "9"}
  function parse(qs) {
    var result = {};

    // if the qs came from window.location.search, it will contain a leading
    // '?' that we want to remove.
    if (qs.charAt(0) === '?') {
      qs = qs.slice(1);
    }

    if (qs.length === 0) {
      return result;
    }

    qs.split('&').forEach(function (keyValueStr) {
      var key, value;
      var idx = keyValueStr.indexOf('=');

      if (idx === -1) {
        key = keyValueStr;
        value = '';
      } else {
        key = keyValueStr.substr(0, idx);
        value = keyValueStr.substr(idx + 1);
      }

      result[decodeURIComponent(key)] = decodeURIComponent(value);
    });

    return result;
  }


  c2.querystring = {
    stringify: stringify,
    parse: parse
  };
})(window.c2);
